import { TextField } from "@mui/material"
import { toast } from "react-toastify" // ajusta al import real que uses

/**
 * Input de texto que solo permite dígitos (sin convertir a Number).
 * Úsalo para: CLABE, número de cuenta, tarjeta — cualquier identificador
 * donde el formato exacto (incluyendo ceros a la izquierda) importa.
 */
export default function InputDigits({
	label,
	value,
	onChange,
	maxLength,
	invalidCharMessage = "Solo se permiten números",
	maxLengthMessage,
	disabled = false,
	fullWidth = true,
	size = "medium",
}) {
	const handleChange = (event) => {
		const raw = event.target.value

		if (!/^\d*$/.test(raw)) {
			toast.error(invalidCharMessage)
			return
		}

		if (maxLength && raw.length > maxLength) {
			toast.error(maxLengthMessage ?? `Máximo ${maxLength} dígitos`)
			return
		}

		onChange(raw)
	}

	return (
		<TextField
			label={label}
			fullWidth={fullWidth}
			disabled={disabled}
			size={size}
			type="text"
			inputMode="numeric"
			value={value ?? ""}
			onChange={handleChange}
			autoComplete="off"
		/>
	)
}